import { z } from 'zod';
import { UserPublic } from '../client';
import { makeEvent } from './EventBase';

export const OnboardingApproved = makeEvent(
    'OnboardingApproved',
    z.object({
        data: UserPublic,
    }),
);

export type OnboardingApproved = (typeof OnboardingApproved)['schema']['_output'];
